import * as React from 'react';
import cx from 'classnames';
import BurgerIcon from './BurgerIcon';
import styles from './NavigationBurger.module.scss';

const NavigationBurger = ({ theme, pressed, ...buttonProps }) => (
  <button className={cx(styles.base, styles[`base_theme_${theme}`])} type="button" {...buttonProps}>
    <div className={styles.iconHolder}>
      <BurgerIcon close={pressed} />
    </div>
  </button>
);

export default NavigationBurger;
